<template>
    <div class="column is-one-third">
        <div class="card">
            <div v-if="successfulOutcome" class="card-content">
                <div class="has-text-centered has-text-success">
                    <b-icon icon="check" size="is-large"></b-icon>
                    <p>Email enviado con exito!</p>
                    <p>Dirigete a tu casilla de correo para continuar el proceso</p>
                </div>
            </div>
            <div v-else class="card-content">
                <div class="has-text-centered">
                    <img :src="logo" style="max-width:50%;" alt="logo">
                </div>
                    <label >Email</label>
                    <div class="field">
                        <p class="control has-icons-left">
                            <input 
                            type="email"
                            v-model="email"
                            class="input is-rounded is-light" 
                            placeholder="username@email.com" 
                            style="border:0.8px solid var(--primary)">
                            <span class="icon is-small is-left">
                                <i class="fas fa-envelope"></i>
                            </span>
                        </p>
                    </div>
                    <b-field>
                        <VueRecaptcha @verify="verifyCaptcha" sitekey="6LcHavwUAAAAAGnN37OSgSLR7e9XfivBHo7xGRwd"/>
                    </b-field>
                    <div class="has-text-centered">
                        <b-button 
                        rounded
                        style="background:var(--primary); color:var(--text-color)"
                        @click="sendEmail"
                        :disabled="disabledBtn"
                        :loading="loading">
                            Resetear clave para este email
                            <span class="m-l-10 icon is-small">
                                <i class="fas fa-paper-plane"></i>
                            </span>
                        </b-button>
                    </div>
            </div>
            
        </div>
        <div class="has-text-centered m-t-20">
            <a href="https://traction.cloud" class="has-text-dark">
                Powered by 
            <img src="../../../assets/logo.png" style="max-height:18px; vertical-align:centered;" alt="logo">
            </a>
        </div>
    </div>
</template>

<script>
import { postHandler } from '../../../services/http';
import VueRecaptcha from "vue-recaptcha";

export default {
    components:{
        VueRecaptcha
    },
    props:{
        logo:{
            type:String,
            default:""
        },
        resetUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            email:"",
            loading:false,
            successfulOutcome:false,
            captchaToken:""
        }
    },
    methods:{
        async sendEmail(){
            let success = {
                resource:"notify",
                text:"Email enviado con exito"
            }
            let error = {
                resource:"notify",
                text:"No existe un usuario que este usando ese email"
            }
            this.loading = true
            var data = {
                email:this.email,
                captchaToken:this.captchaToken
            }
            let res = await postHandler(this.resetUrl, data, {error, success})
            this.loading = false
            if(res.status == 200){
                this.successfulOutcome=true
            }
        },
        verifyCaptcha(token){
            this.captchaToken=token
            this.disabledBtn
        }
    },
    computed:{
        disabledBtn(){
            if (!this.captchaToken.length || !this.email.length){
                return true 
            }
            return false
        }
    }
}
</script>